import { useEffect, useState } from "react"
import CheckoutModal from "../../CheckoutModal"
import axiosInstance from "../../../Services/Api"

const Etapa3 = ({ setEtapas, productData }) => {
    const [modalCheckoutOpen, setModalCheckoutOpen] = useState(false)
    const [checkout, setCheckout] = useState([])
    const [checkoutId,setCheckoutId] = useState('')
    useEffect(() => {
        (async () => {
            console.log(productData)
            if (productData.id) {
               await getCheckout(productData.id)

            }
        })()
    }, [])

    const getCheckout = async (productId)=>{
        try {
            const response = await axiosInstance.get(`/checkout/getCheckout/${productId}`)
            console.log(response.data)
            setCheckout(response.data.checkout)
            setCheckoutId(response.data.checkoutId)
        } catch (error) {
            if (error.status === 401) {
                window.localStorage.removeItem('token')
                window.location.href = '/#/login'
            }
        }
    }
    return (
        <div className="mt-3 md:z-0  z-[99999] relative">
            <div className="flex justify-between">
                <input className="w-[40%] rounded-[8px] text-[14px] px-4 bg-[#313131]" type="search" placeholder="Buscar" />
                <div onClick={() => { setModalCheckoutOpen(true) }} className="bg-[#478DF8] cursor-pointer items-center text-[12px] flex gap-2 p-1 px-2 rounded-[10px]">
                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 4.96875C7.6409 4.96875 7.77602 5.02472 7.87565 5.12435C7.97528 5.22398 8.03125 5.3591 8.03125 5.5V6.5625H9.09375C9.23465 6.5625 9.36977 6.61847 9.4694 6.7181C9.56903 6.81773 9.625 6.95285 9.625 7.09375C9.625 7.23465 9.56903 7.36977 9.4694 7.4694C9.36977 7.56903 9.23465 7.625 9.09375 7.625H8.03125V8.6875C8.03125 8.8284 7.97528 8.96352 7.87565 9.06315C7.77602 9.16278 7.6409 9.21875 7.5 9.21875C7.3591 9.21875 7.22398 9.16278 7.12435 9.06315C7.02472 8.96352 6.96875 8.8284 6.96875 8.6875V7.625H5.90625C5.76535 7.625 5.63023 7.56903 5.5306 7.4694C5.43097 7.36977 5.375 7.23465 5.375 7.09375C5.375 6.95285 5.43097 6.81773 5.5306 6.7181C5.63023 6.61847 5.76535 6.5625 5.90625 6.5625H6.96875V5.5C6.96875 5.3591 7.02472 5.22398 7.12435 5.12435C7.22398 5.02472 7.3591 4.96875 7.5 4.96875ZM14.4062 2.84375V10.2812C14.4062 10.563 14.2943 10.8333 14.0951 11.0326C13.8958 11.2318 13.6255 11.3438 13.3438 11.3438H1.65625C1.37446 11.3438 1.10421 11.2318 0.904949 11.0326C0.705692 10.8333 0.59375 10.563 0.59375 10.2812V1.25C0.59375 0.968207 0.705692 0.697956 0.904949 0.498699C1.10421 0.299442 1.37446 0.1875 1.65625 0.1875H5.1977C5.4275 0.18807 5.65101 0.262576 5.8352 0.4L7.6773 1.78125H13.3438C13.6255 1.78125 13.8958 1.89319 14.0951 2.09245C14.2943 2.29171 14.4062 2.56196 14.4062 2.84375ZM1.65625 3.375H5.1977L6.6148 2.3125L5.1977 1.25H1.65625V3.375ZM13.3438 2.84375H7.6773L5.8352 4.225C5.65101 4.36242 5.4275 4.43693 5.1977 4.4375H1.65625V10.2812H13.3438V2.84375Z" fill="white" />
                    </svg>
                    Adicionar checkout
                </div>
            </div>
            <table className="w-full min-w-full overflow-x-auto gap-4 mt-4  gap-4 mt-4">
                <thead className="text-[14px]  border-b border-[#343B4F] text-left w-full justify-between gap-3 items-center">
                    <th>Data</th>
                    <th>Nome</th>
                    <th>Preço</th>
                    <th>Oferta</th>

                </thead>
                <tbody className="min-w-full" style={{ paddingTop: '16px' }}>
                    {checkout.map((data) => (
                        <tr key={data.id} className="text-[12px] pt-4 w-full border-[#343B4F]">
                            <td className="pt-4">{new Date(data.created_at).toLocaleString('pt-BR', {
                                timeZone: 'America/Sao_Paulo',
                                day: '2-digit',
                                month: 'numeric',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false
                            })}</td>
                            <td className="pt-4">{data.name}</td>
                            <td className="pt-4">
                                {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.price)}
                            </td>
                            <td className="pt-4">
                                <a href={`/#/checkout/${checkoutId}`} className="flex items-center">
                                    Link
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 ml-2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                                    </svg>
                                </a>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>

            <div onClick={() => { setEtapas(3) }} className="flex gap-2 mt-2  text-[14px]">
                <div className="px-2 cursor-pointer flex gap-2 items-center p-1 rounded-[8px] bg-[#478DF8]">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.5 7.96875C8.6409 7.96875 8.77602 8.02472 8.87565 8.12435C8.97528 8.22398 9.03125 8.3591 9.03125 8.5V9.5625H10.0938C10.2346 9.5625 10.3698 9.61847 10.4694 9.7181C10.569 9.81773 10.625 9.95285 10.625 10.0938C10.625 10.2346 10.569 10.3698 10.4694 10.4694C10.3698 10.569 10.2346 10.625 10.0938 10.625H9.03125V11.6875C9.03125 11.8284 8.97528 11.9635 8.87565 12.0632C8.77602 12.1628 8.6409 12.2188 8.5 12.2188C8.3591 12.2188 8.22398 12.1628 8.12435 12.0632C8.02472 11.9635 7.96875 11.8284 7.96875 11.6875V10.625H6.90625C6.76535 10.625 6.63023 10.569 6.5306 10.4694C6.43097 10.3698 6.375 10.2346 6.375 10.0938C6.375 9.95285 6.43097 9.81773 6.5306 9.7181C6.63023 9.61847 6.76535 9.5625 6.90625 9.5625H7.96875V8.5C7.96875 8.3591 8.02472 8.22398 8.12435 8.12435C8.22398 8.02472 8.3591 7.96875 8.5 7.96875ZM15.4062 5.84375V13.2812C15.4062 13.563 15.2943 13.8333 15.0951 14.0326C14.8958 14.2318 14.6255 14.3438 14.3438 14.3438H2.65625C2.37446 14.3438 2.10421 14.2318 1.90495 14.0326C1.70569 13.8333 1.59375 13.563 1.59375 13.2812V4.25C1.59375 3.96821 1.70569 3.69796 1.90495 3.4987C2.10421 3.29944 2.37446 3.1875 2.65625 3.1875H6.1977C6.4275 3.18807 6.65101 3.26258 6.8352 3.4L8.6773 4.78125H14.3438C14.6255 4.78125 14.8958 4.89319 15.0951 5.09245C15.2943 5.29171 15.4062 5.56196 15.4062 5.84375ZM2.65625 6.375H6.1977L7.6148 5.3125L6.1977 4.25H2.65625V6.375ZM14.3438 5.84375H8.6773L6.8352 7.225C6.65101 7.36242 6.4275 7.43693 6.1977 7.4375H2.65625V13.2812H14.3438V5.84375Z" fill="white" />
                    </svg>
                    Salvar Checkout
                </div>
                <div className="bg-[#444444] cursor-pointer rounded-[8px] px-2 p-1 items-center">cancelar</div>
            </div>
            {modalCheckoutOpen && <CheckoutModal productId={productData.id} getCheckout={getCheckout} setCheckoutModalOpen={setModalCheckoutOpen} />}
        </div>
    )
}

export default Etapa3